<template>
  <guide
    :button-text="{
      next: '下一步',
      prev: '上一步',
      done: '完成',
    }"
    container="#titan-main-app"
    :options="mateGuideLayoutV2"
    :local-storage-key="'mate-guide'"
  >
  </guide>
  <layout-component>
    <template
      #default="{
        headerHeight,
        sidebarWidth,
      }: {
        sidebarWidth: number,
        headerHeight: number,
      }"
    >
      <micro-app-container
        :header-height="headerHeight"
        :sidebar-width="sidebarWidth"
        :theme="useLayoutV1 ? 'v1' : 'v2'"
        v-loading="{
          isShow: globalStore.fullScreenLoading,
          loadingType: 'circle',
          textOrient: 'row',
          text: '加载中...',
          size: 'middle',
          bgc: 'rgba(210,210,210,0.7)',
        }"
      ></micro-app-container>
    </template>
  </layout-component>
  <allow-bind-account-dialog ref="bindAccountDialogRef" />
  <lane-switcher
    v-if="['dev', 'test', 'stg'].includes(globalStore.userInfo.env)"
  />
</template>

<script setup lang="ts">
import { Guide } from '@nio-wad/beach';
import MicroAppContainer from '@/components/MicroAppContainer/MicroAppContainer.vue';
import useGlobalStore from '@/store/globalStore';
import { onMounted, ref } from 'vue';
import AllowBindAccountDialog from '@/components/AllowBindAccountDialog/AllowBindAccountDialog.vue';
import Cookies from 'js-cookie';
import LayoutV2 from '@/components/LayoutV2/LayoutV2.vue';
import LayoutV1 from '@/components/layout/LayoutV1.vue';
import { mateGuideLayoutV2 } from '@/guides';
const globalStore = useGlobalStore();
const bindAccountDialogRef = ref();
// const useLayoutV1 = Cookies.get('mate-layout') === 'v1';
const LayoutComponent = LayoutV2;
import LaneSwitcher from '@/components/LaneSwitcher/LaneSwitcher.vue';

onMounted(() => {
  bindAccountDialogRef.value.checkAndIfOpenDialog();
});
</script>

<style lang="scss" scoped></style>
